<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Case Managers:</h4>
                <div>
                    <SingleMembershipEditor :fields="[{name: 'Employee.Person.FullName', title: 'NAME'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                            :field-data="CaseManagers"
                                            :edit-mode="EditMode"
                                            select-label="Case Manager:"
                                            options-type="API"
                                            options-method="Core/EmployeeCaseload/GetAvailableCMEmployees"
                                            options-method-record-name="ClientSubProgramMembershipID"
                                            :options-method-record-id="ChildRecordData.Id"
                                            add-record-method="Core/EmployeeCaseload/AddClientToEmployeeCaseload"
                                            add-record-record-property-name="EmployeeID"
                                            :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id,
                                                                             EmployeeRole: 'Case Manager'}"
                                            add-record-modal-title="Add Initial Case Manager"
                                            transfer-record-method="Core/EmployeeCaseload/TransferCMMembership"
                                            transfer-record-record-property-name="EmployeeID"
                                            :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id,
                                                                                  EmployeeRole: 'Case Manager'}"
                                            transfer-record-modal-title="Transfer Case Managers"
                                            transfer-record-effective-date-property-name="StartDate"
                                            delete-record-method="Core/EmployeeCaseload/DeleteCurrentCMMembership"
                                            :delete-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                            delete-record-modal-title="Delete Current Case Manager"
                                            delete-record-modal-text="NOTICE: You are about to delete this client's current Case Manager.  If there was a previous Case Manager assigned, the child will be re-assigned to them." />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Professionals:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/Professionals/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/Professionals/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/Professionals/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Professionals"
                                           :relationship-options="ProfessionalOptions"
                                           relationship-label="Child"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :professional-dropdown-enabled="true"
                                           professional-dropdown-enabled-endpoint="Core/Clients/Contacts/Professionals/GetAllContactsInSubProgram"
                                           :professional-dropdown-enabled-payload="{Id: ChildRecordData.SubProgramID}"
                                           :display-agency="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Biological Family:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/BiologicalFamily/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/BiologicalFamily/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/BiologicalFamily/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Biological Family"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Child"
                                           :display-age="true"
                                           :display-relationship="true"
                                           :agency-input="false"
                                           :display-agency="false" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Household Members (Living with Youth):</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/HouseholdMembers/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/HouseholdMembers/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/HouseholdMembers/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Household Members"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Child"
                                           :display-age="true"
                                           :display-relationship="true"
                                           :agency-input="false"
                                           :display-agency="false" />
                </div>
            </div>
        </div>
        <!--<div class="row">
        <div class="col">
            <h4>Church Relationships:</h4>
            <div>
                <ContactDisplayAndEdit :edit-mode="EditMode"
                                       :global-update="false"
                                       get-endpoint="Core/ChildAbuseStopsHere/GetContacts"
                                       :get-payload="{Id: ChildRecordData.Id}"
                                       add-edit-endpoint="Core/ChildAbuseStopsHere/AddEditContact"
                                       :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                       delete-endpoint="Core/ChildAbuseStopsHere/DeleteContact"
                                       :require-dob="false"
                                       contact-category="Church Relationship"
                                       :relationship-options="null"
                                       relationship-label="Child"
                                       :display-age="false"
                                       :display-relationship="true"
                                       :church-input="true"
                                       :display-church="true" />
            </div>
        </div>
    </div>-->
        <div class="row record-section-row">
            <div class="col">
                <h4>Informal Relationships:</h4>
                <div>
                    <InformalRelationshipsDisplayAndEdit :edit-mode="EditMode"
                                                         :chart-id="ChildRecordData.Id"
                                                         :client-first-name="ChildRecordData.Client.Person.FirstName" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Misc:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/Misc/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/Misc/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/Misc/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Misc"
                                           :relationship-options="null"
                                           relationship-label="Child"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :display-agency="true" />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor';
    import ContactDisplayAndEdit from '../../../Core/ItemEditors/ContactDisplayAndEdit.vue';
    import InformalRelationshipsDisplayAndEdit from '../../../Core/ItemEditors/InformalRelationshipsDisplayAndEdit.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            SingleMembershipEditor,
            ContactDisplayAndEdit,
            EditMode,
            InformalRelationshipsDisplayAndEdit
        },
        mounted() {

        },
        computed: {
            GetSubProgramTerminationReasons: function () {
                let subprogram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.SubProgramID);
                let returnObj = [];
                if (subprogram.DischargeReasons.length > 0) {
                    subprogram.DischargeReasons.forEach(function (item) {
                        returnObj.push({ text: item.Label, value: item.Id });
                    })
                }
                return returnObj;
            },
            ProfessionalOptions: function () {
                return this.$store.state.Options.ProfessionalTypes;
            },
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            },
            CaseManagers: function () {
                let output = this.ChildRecordData.EmployeeCaseloads.filter(ec => ec.EmployeeRole == 'Case Manager');
                return output;
            }
        }
    }
</script>

<style scoped>
</style>